namespace TR {
    class FacilitiesFilter {
        model: any;
        aggregate: any;
        limits: any;
        showPrice: any;
        showAll: any;
        groupArray: any;
        people: any;

        facLimit: string;
        htLimit: string;

        constructor($scope: ng.IScope,
                    occupancyService: Core.OccupancyService) {
            this.limits = {};
            this.showPrice = {};
            $scope.$watch('ff.aggregate', agg => {
                if (!agg) { return; }
                this.people = occupancyService.getNumberOfNonInfantPassengers();
                let groupArray:any = [];
                for (let group in agg) {
                    let elementArray:any = [];

                    if (group === 'Facilities') {
                        this.limits[group] = parseInt(this.facLimit, 10);
                        this.showPrice[group] = false;
                    } else {
                        this.limits[group] = parseInt(this.htLimit, 10);
                        this.showPrice[group] = true;
                    }

                    for (let key in agg[group]) {
                        elementArray.push(_.extend(agg[group][key], { id: key }));
                    }
                    _.minBy(elementArray, (v:any) => v.MinPrice).cheapest = true;
                    groupArray.push({ title: group, elements: _.clone(elementArray) });
                }
                this.groupArray = groupArray;
            });
            this.showAll = {};
        }

        isSet(group) {
            if (!this.aggregate[group] || !this.model) { return; }
            const keys = Object.keys(this.aggregate[group]);
            return _.intersection(this.model, keys).length > 0;
        }

        reset(group) {
            const keys = Object.keys(this.aggregate[group]);
            this.model = _.difference(this.model, keys);
        }

        more(group: string, all: boolean) {
            this.showAll[group] = all;
        }

        showMoreLess(group) {
            return Object.keys(this.aggregate[group] || {}).length > this.limits[group];
        }
    }

    angular
        .module('TR')
        .directive('facilitiesFilter', (): ng.IDirective => {
            return {
                scope: {},
                templateUrl: 'partials/home/directivetemplate?type=FacilitiesFilter',
                bindToController: {
                    aggregate: '=',
                    model: '=',
                    facLimit: '@',
                    htLimit: '@',
                    priceMode: '='
                },
                controller: FacilitiesFilter,
                controllerAs: 'ff'
            };
        });

    class FacilitiesFilterLabel {

        public static getTemplate() {
            return `
                <span ng-if="ff.isSet()">
                    <a
                        href="#"
                        ng-repeat="item in ff.model"
                        class="filter-criterion-toggle"
                        ng-click="ff.remove(item)">
                        <span> {{ff.getName(item)}} </span>
                    </a>
                </span>
            `;
        }

        model: any;
        aggregate: any;

        constructor($scope: ng.IScope, analytics: any) {
            $scope.$watch('ff.model', (value: any) => {
                if (!value || !value.length) { return; }
                const grouped = this._getNameGrouped(value);
                for (let group in grouped) {
                    analytics.track(
                        'mixpanel',
                        `HolidayDealsFilter${group.replace(' ', '')}`,
                        { value: grouped[group] }
                    );
                }
            });
        }

        getName(item) {
            if (!this.aggregate) { return ''; }
            for (let group in this.aggregate) {
                const filter = this.aggregate[group][item];
                if (filter) { return filter.Title; }
            }
        }

        isSet() {
            return !!_.size(this.model);
        }

        remove(dest) {
            this.model = this.model.filter(v => v !== dest);
        }

        private _getNameGrouped(filter) {
            if (!this.aggregate) { return ''; }
            let grouped = {};
            for (let i = 0, ii = filter.length; i < ii; i++) {
                let filterValue = filter[i];
                for (let group in this.aggregate) {
                    let item = this.aggregate[group][filterValue];
                    if (item) {
                        if (!grouped[group]) { grouped[group] = []; }
                        grouped[group].push(item.Title);
                    }
                }
            }
            return grouped;
        }
    }

    angular
        .module('TR')
        .directive('facilitiesFilterLabel', (): ng.IDirective => {
            return {
                scope: {},
                template: FacilitiesFilterLabel.getTemplate(),
                bindToController: {
                    aggregate: '=',
                    model: '='
                },
                controller: FacilitiesFilterLabel,
                controllerAs: 'ff'
            };
        });

}
